import { render, staticRenderFns } from "./ErrorCorrectionLeaderboard.vue?vue&type=template&id=ba1fe45e&scoped=true&"
import script from "./ErrorCorrectionLeaderboard.vue?vue&type=script&lang=js&"
export * from "./ErrorCorrectionLeaderboard.vue?vue&type=script&lang=js&"
import style0 from "./ErrorCorrectionLeaderboard.vue?vue&type=style&index=0&id=ba1fe45e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba1fe45e",
  null
  
)

export default component.exports